export enum ApiColIDs {
  app_id = 'app_id',
  created_at = 'created_at',
  expires_at = 'expires_at',
  name = 'name',
  delete = 'delete'
}
